import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { IBotInfo } from 'src/app/models/bot-info';
import { Subscription } from 'rxjs';
import { IBotRegistration } from 'src/app/models/bot-registration';
import { BotRegistrationService } from 'src/app/services/core/bot-registration/bot-registration.service';
import { ToasterService } from 'src/app/services/shared/toaster/toaster.service';

@Component({
  selector: 'app-botregister',
  templateUrl: './botregister.component.html',
  styleUrls: ['./botregister.component.scss']
})
export class BotregisterComponent implements OnInit {

  newBotRegisterForm: FormGroup;
  OfferingType: FormControl;
  HILTier: FormControl;
  BotId: FormControl;
  BotName: FormControl;
  BotType: FormControl;
  ClientName: FormControl;
  ServiceLine: FormControl;
  ReportId: FormControl;
  AgentChatAllocations: FormControl;
  ChatHistoryDisplayPeriod: FormControl;
  status: string;
  botConfigDetails: {
    botId: any,
    displayName: string,
    serviceLine: string,
    id: number
  }
  botRegistrationDetails: IBotRegistration;
  botRegistrationId: number;
  botConfigId: number;
  registeredBotData: IBotInfo;
  private _subscriptions = new Subscription();
  offeringTypes: string[] = [];
  hilTiers: string[] = [];
  addBotRegistration: boolean = false;
  hasError: boolean = false;
  constructor(private _botRegistrationService: BotRegistrationService,
    private _toaster: ToasterService,
    private router: Router,
    private route: ActivatedRoute) { }

  ngOnInit() {
    this.hasError = false;
    this.OfferingType = new FormControl('', Validators.required)
    this.HILTier = new FormControl('', Validators.required)
    this.BotId = new FormControl('', Validators.required)
    this.BotName = new FormControl({ value: '', disabled: true }, Validators.required)
    this.BotType = new FormControl('', Validators.required)

    this.ClientName = new FormControl('', Validators.compose([Validators.required, Validators.maxLength(200), Validators.pattern(/^[ a-zA-Z0-9]+$/)]))

    this.ServiceLine = new FormControl({ value: '', disabled: true }, Validators.required)
    this.ReportId = new FormControl('', Validators.pattern(/^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i))
    this.AgentChatAllocations = new FormControl('', [Validators.min(1)])
    this.ChatHistoryDisplayPeriod = new FormControl('', [Validators.min(1)])
    this.newBotRegisterForm = new FormGroup({
      OfferingType: this.OfferingType,
      HILTier : this.HILTier,
      BotId: this.BotId,
      BotName: this.BotName,
      BotType: this.BotType,
      ClientName: this.ClientName,
      ServiceLine: this.ServiceLine,
      ReportId: this.ReportId,
      AgentChatAllocations: this.AgentChatAllocations,
      ChatHistoryDisplayPeriod: this.ChatHistoryDisplayPeriod
    })
    this._subscriptions.add(
      this._botRegistrationService.getBotRegistrationConfigurations()
        .subscribe(
          res => {
            this.offeringTypes = res.offeringTypes;
            this.hilTiers = res.hilTiers;
          },
          (error) => {                        
            this.hasError = true;
          }
        )
    )
    //For Edit
    this._subscriptions.add(
      this.route.queryParams.subscribe(params => {
        this.botRegistrationId = params['Id'];
      }));

    if (this.botRegistrationId && this.botRegistrationId != 0) {
      this._subscriptions.add(
        this._botRegistrationService.getRegisteredBotDetails(this.botRegistrationId)
          .subscribe(
            res => {
              this.registeredBotData = res;
              this.ServiceLine.setValue(this.registeredBotData.serviceLine);
              this.BotName.setValue(this.registeredBotData.displayName);
              this.BotId.setValue(this.registeredBotData.botId);
              this.newBotRegisterForm.controls['BotId'].disable();
              this.OfferingType.setValue(this.registeredBotData.offeringType);
              this.HILTier.setValue(this.registeredBotData.hilTier);
              this.BotType.setValue(this.registeredBotData.botType);
              this.ClientName.setValue(this.registeredBotData.customerContact);
              this.ReportId.setValue(this.registeredBotData.reportId);
              this.AgentChatAllocations.setValue(this.registeredBotData.agentChatAllocations);
              this.ChatHistoryDisplayPeriod.setValue(this.registeredBotData.chatLogDisplayPeriod)
            },
            (error) => {
              this._toaster.error("Unable to retrieve BOT details");
              this.hasError = true;
            }
          )
      )
    }
  }

  registerBotSave(formValues) {
    this.addBotRegistration = true;
    //Bot Registration Edit
    if (this.botRegistrationId && this.botRegistrationId != 0) {
      this.botRegistrationDetails = {
        botConfigId: this.registeredBotData.botConfigId,
        customerContact: formValues.ClientName,
        botType: formValues.BotType,
        offeringType: formValues.OfferingType,
        hilTier : formValues.HILTier,
        isActive: true,
        id: this.registeredBotData.botRegistrationId,
        reportId: formValues.ReportId == "" ? null : formValues.ReportId,
        agentChatAllocations: formValues.AgentChatAllocations,
        chatLogDisplayPeriod: formValues.ChatHistoryDisplayPeriod
      }
    }
    // New Bot Registration
    else {
      this.botRegistrationDetails = {
        botConfigId: this.botConfigDetails.id,
        customerContact: formValues.ClientName,
        botType: formValues.BotType,
        offeringType: formValues.OfferingType,
        hilTier: formValues.HILTier,
        isActive: true,
        id: 0,
        reportId: formValues.ReportId == "" ? null : formValues.ReportId,
        agentChatAllocations: formValues.AgentChatAllocations,
        chatLogDisplayPeriod: formValues.ChatHistoryDisplayPeriod
      }
    }
    this._subscriptions.add(
      this._botRegistrationService.addUpdateBotRegistration(this.botRegistrationDetails)
        .subscribe(
          res => {
            this.addBotRegistration = false;
            if (this.botRegistrationId && this.botRegistrationId != 0)
              this._toaster.success("Bot registration updated successfully!!");
            else
              this._toaster.success("Bot registered successfully!!");
            this.newBotRegisterForm.reset();
            this.router.navigate(['administration/botlookup']);
          },
          (error) => {            
            this.addBotRegistration = false;
          }
        )
    )
  }

  resetform() {
    this.newBotRegisterForm.reset();
  }

  valuechange(event) {

    this._subscriptions.add(
      this._botRegistrationService.getBotConfigData(event.currentTarget.value)
        .subscribe(
          res => {
            if (res) {
              this.hasError = false;
              this.OfferingType.enable();
              this.HILTier.enable();
              this.ClientName.enable();
              this.ReportId.enable();
              this.AgentChatAllocations.enable();
              this.BotType.enable();
              this.botConfigDetails = res;
              this.ServiceLine.setValue(this.botConfigDetails.serviceLine);
              this.BotName.setValue(this.botConfigDetails.displayName);
              this.ChatHistoryDisplayPeriod.enable();
            }
            else {
              this._toaster.error("Bot Not Found");
              this.hasError = true;
              this.ServiceLine.setValue("");
              this.BotName.setValue("");
              this.OfferingType.disable();
              this.HILTier.disable();
              this.ClientName.disable();
              this.ReportId.disable();
              this.AgentChatAllocations.disable();
              this.BotType.disable();
              this.ChatHistoryDisplayPeriod.disable();
            }
          },
          (error) => {
            this.hasError = true;
            this.ServiceLine.setValue("");
            this.BotName.setValue("");
            this.OfferingType.disable();
            this.HILTier.disable();
            this.ClientName.disable();
            this.ReportId.disable();
            this.AgentChatAllocations.disable();
            this.BotType.disable();
            this.ChatHistoryDisplayPeriod.disable();
          }
        )
    )
  }

  ngOnDestroy(): void {
    this._subscriptions.unsubscribe();
  }


}
